<template>
  <v-container>
    <h1>{{ action }} Devotional Set</h1>
    <v-form>
      <v-alert
        v-model="isError"
        dismissible
        type="error"
        transition="fade-transition"
      >
        {{ errMessage }}
      </v-alert>

      <v-text-field
        v-model="set.index"
        label="Index"
        :error-messages="errors.index"
        id="index"
        @focus="inputFocus"
      />

      <v-checkbox
        v-model="set.isFixed"
        label="Always available to users?"
        :error-messages="errors.isFixed"
        id="isFixed"
        @focus="inputFocus"
      />

      <v-text-field
        v-model="set.title"
        label="Title"
        :error-messages="errors.title"
        id="title"
        @focus="inputFocus"
      />

      <v-btn
        @click="submit"
      >Save</v-btn>
    </v-form>
  </v-container>
</template>

<script>

export default {
  data: () => ({
    set: {
      index: null,
      isFixed: false,
      title: null
    },

    isError: false,
    errMessage: null,
    errors: {
      index: null,
      isFixed: null,
      title: null
    }
  }),
  computed: {
    action: function () {
      let id = this.$route.params.id
      if (id === 'new') {
        return 'Add'
      } else {
        return 'Edit'
      }
    }
  },
  mounted: function () {
    let id = this.$route.params.id
    // If we're making a new set, we're done
    if (id === 'new') {
      return
    }

    // Otherwise, we need to load data for the set
    var _this = this
    this.axios.get('/devotionals/sets/' + id)
      .then(function (res) {
        // Sanity check before assigning the value
        if (res.data.length > 0) {
          _this.set = res.data[0]
        } else {
          throw new RangeError('No devotional set information returned')
        }
      })
      .catch(this.$root.apiErrorHandler(function (msg, errors, err) {
        // If our error is a 404, that means we got a bogus set ID value and
        // we can safely abort back to the set listing page. Otherwise, we want
        // to render our error message.
        if (err && err.response && err.response.status === 404) {
          return _this.$router.push('/admin/devotionals')
        } else {
          _this.errMessage = msg
          _this.isError = true
        }
      }))
  },
  methods: {
    submit: function (ev) {
      var _this = this

      // Set up the proper request based on whether we're editing or creating
      let url = '/devotionals/sets'
      let method = 'POST'
      let id = this.$route.params.id
      if (id !== 'new') {
        url += '/' + id
        method = 'PUT'
      }

      // Now send the POST or PUT request
      this.axios.request({
        method,
        url,
        data: this.set
      })
        .then(function (res) {
          _this.$router.push('/admin/devotionals')
        })
        .catch(this.$root.apiErrorHandler(function (msg, errors) {
          _this.errMessage = msg
          _this.errors = errors
          _this.isError = true
        }))
    },
    inputFocus (ev) {
      // Clear any errors for an input when it receives focus
      if (ev.target && ev.target.id) {
        this.errors[ev.target.id] = null
      }
    }
  }
}
</script>
